import {
  modelPkgTable,
  modelTable,
  modelPkgData,
  modelData
} from "../data/EvaModel";
import { ElMessage } from "element-plus";
import SeasonSelect from "@/components/SeasonSelect.vue";
import { post } from "../utils/request";
import NormSelect from "@/components/NormSelect.vue";
import NormSelectV2 from "@/components/NormSelectV2.vue";
import RoleSelect from "@/components/RoleSelect.vue";
import EvaTypeSelect from "@/components/EvaTypeSelect.vue";
import moment from "moment";
import { seasonTransfer, getRoleName, getNormNameByTypeId } from "../utils/utilApi";

export default {
  data() {
    return {
      year: String(new Date().getFullYear()),
      showableComp: {
        showAddModel: false,
        showAddModelPkg: false,
        showModelSubject: true,
        showSeasonNorm: false,
      },
      disable: {
        addModelPkgBtn: false,
        addModelBtn: false,
      },
      modelPkgTable: [],
      modelTable: [],
      modelPkgData: [],
      modelData: [],
      objectTypeArr: [
        {
          value: 2,
          label: "科室",
        },
        {
          value: 1,
          label: "个人",
        },
      ],
      newPkg: {
        id: "",
        name: "",
        season: "",
        period: "",
      },
      selectedPkg: "",
      newModel: {
        modelId: "",
        modelName: "",
        modelType: "",
        available: "1",
        normName: "",
        normId: "",
        period: "",
        object: "",
        subject: [],
        season: "",
        // 考核对象类型：1为个人2为科室，
        objectType: "",
        // 该指标在被评分者总分中占的比例
        proportion: "",
        score: "",
        connect: "",
        subjectModelList: [],
      },
      subjectModel: {
        id: "",
        modelId: "",
        subjectId: "",
        subjectName: "",
        evaType: "",
        proportion: "",
        isOk: false,
      },
      evaOverView: [],
      copyFlag: false,
    };
  },
  components: { SeasonSelect, NormSelect, RoleSelect, EvaTypeSelect, NormSelectV2 },
  name: "EvaModel",
  methods: {
    // 是否可用格式转换
    formatter(row, column) {
      if (column.property == "available") {
        return row.available == false ? "否" : "是";
      } else if (column.property == "object") {
        return getRoleName(row.object);
      } else if (column.property == "subject") {
        return getRoleName(row.subject);
        // return row.subject;
      } else if (column.property == "evaType") {
        return row.evaType.join(",");
      } else if (column.property == "season") {
        return seasonTransfer(row.season);
      } else if (column.property == "normId") {
        return row.normName;
      } else {
        return row[column.property];
      }

    },
    doCancel() {
      this.showableComp.showAddModelPkg = false;
    },
    rowDoubleClick(row, event, column) {
      row.isOk = !row.isOk;
    },
    // 展示添加模型库表单
    handleAddModelPkg() {
      // 初始化表单
      this.newPkg = [];
      this.showableComp.showAddModelPkg = true;
      this.copyFlag = false;
    },
    // 展示添加模型表单
    handleAddModel() {
      // 如果未选择模型库则提示
      if (this.selectedPkg == "") {
        ElMessage.warning("请先在左侧选择考核模型库", {
          duration: 3 * 1000,
        });
        return;
      }
      // this.newModel = [];
      this.newModel = this.$options.data().newModel;
      this.disable.addModelBtn = false;
      this.showableComp.showAddModel = true;
    },
    // 点击选择模型库
    selectPkg(row, col, event) {
      this.selectedPkg = row;
      console.info(this.selectedPkg)
      this.searchEvaModel();
    },
    // 查看模型库
    handleEditPkg(index, row) {
      this.newPkg = row;
      this.selectedPkg = row;
      this.showableComp.showAddModelPkg = true;
      this.copyFlag = false
    },
    // 查看模型
    handleEditModel(index, row) {
      this.newModel = JSON.parse(JSON.stringify(row));
      this.newModel.subjectModelList = row.subjectList;
      for (let i = 0; i < this.newModel.subjectModelList.length; i++) {
        this.newModel.subjectModelList[i].subjectId = this.newModel.subjectModelList[i].roleId;
      }
      this.newModel.available = row.available == true ? "1" : "0";
      this.disable.addModelBtn = true;
      this.showableComp.showAddModel = true;
    },
    // 当前季度考核模型综述
    handleViewSeasonTotal() {
      this.evaOverView = this.$options.data().evaOverView;
      this.searchNormOverView();
      this.showableComp.showSeasonNorm = true;
    },
    handleAddOverview() {
      this.evaOverView.push({});
    },
    cancelNormOverView() {
      this.showableComp.showSeasonNorm = false;
    },
    /**
     * @description 查询考核综述（总的考核指标和比例），年度、季度、单位限制
     * @function POST /eva/overview/search
     * 
     * @param {int} year 年度
     * @param {String} season 季度: "第一季度等"，需要转化
     * @param {int} bureauId 单位ID
     * 
     * @return 属性名data，data[]中的每一项包含id序号, normType指标类型（1共性指标3关键指标4加减分5民主测评6服务对象测评7党委8考勤），proportion比例
     */
    searchNormOverView() {
      let data = {
        year: this.year,
        season: this.selectedPkg.period,
        bureauId: this.selectedPkg.departmentId,
        pkgId: this.selectedPkg.id,
      };
      console.log(data)
      post('/eva/overview/search', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.evaOverView = JSON.parse(res.data.data);
        }
      });
    },
    /**
     * @description 保存考核综述（总的考核指标和比例）
     * @function POST /eva/overview/save
     * 
     * @param {int} year 年度
     * @param {String} season 季度: "第一季度等"，需要转化
     * @param {int} bureauId 单位ID
     * @param {Object[]} evaOverView[] 综述
     * @param {int} modelPgkId 模型库ID
     * @param {int} evaOverView[].id 序号
     * @param {int} evaOverView[].normName 指标名称
     * @param {int} evaOverView[].normType 指标类型（1共性指标3关键指标4加减分5民主测评6服务对象测评7党委8考勤）
     * @param {int} evaOverView[].proportion 指标所占比例
     * 
     */
    saveNormOverView() {
      let data = {
        year: this.year,
        season: this.selectedPkg.period,
        bureauId: this.selectedPkg.departmentId,
        modelPkgId: this.selectedPkg.id,
        evaOverView: this.evaOverView,
      }
      let totalProportion = 0;
      for (let i = 0; i < this.evaOverView.length; i++) {
        totalProportion += parseInt(this.evaOverView[i].proportion);
        this.evaOverView[i].normName = getNormNameByTypeId(this.evaOverView[i].normType, 2); // 指标类型对应的中文名
        if (Object.keys(this.evaOverView[i]).length === 0) {
          this.evaOverView.splice(i, 1);
        }
      }
      if (totalProportion > 100) {
        ElMessage.warning("总比例和超过了100", {
          duration: 3 * 1000,
        });
        return;
      }
      if (totalProportion == 0) {
        ElMessage.warning("未设置参数无法保存", {
          duration: 3 * 1000,
        });
        return;
      }
      post('/eva/overview/save', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.searchNormOverView();
          this.showableComp.showSeasonNorm = false;
        }
      });
    },
    /**
     * @description 删除考核综述（总的考核指标和比例）
     * @function POST /eva/overview/items/delete
     * 
     * @param id 考核综述中的某一项
     */
    deleteOverview(index, row) {
      // 如果没有保存在数据库中就直接删除
      if (typeof (row.id) == 'undefined') {
        this.evaOverView.splice(index, 1);
        return;
      }
      post('/eva/overview/items/delete', row.id).then((res) => {
        if (res.code == 200) {
          this.evaOverView.splice(index, 1);
        }
      });
    },
    /**
     * @function POST /modelPgk/add
     * @description 添加模型库
     * @param name 模型库名称
     * @param season 季度
     * @param period 周期
     * @param departmentId int 局ID
     * @param year 年度
     * 
     * @returns R.success().code(200).data("id")
     */
    addModelPkg() {
      let data = {
        name: this.newPkg.name,
        season: this.newPkg.season,
        period: this.newPkg.period,
        departmentId: JSON.parse(sessionStorage.getItem('departmentInfo')).departmentId,
        year: this.year,
      };
      post('/modelPkg/add', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          data.id = res.data.modelPgkId;
          this.modelPkgData.push(data);
        }
        this.showableComp.showAddModelPkg = false;
      });
    },
    /**
     * @description 修改模型库信息
     * @function POST /modelPgk/save
     * 
     * @param id 模型库ID
     * @param name 模型库名称
     * @param season 季度
     * @param period 季度，和season属性相同
     * @param departmentId int 局ID
     */
    saveModelPkg() {
      this.newPkg.season = this.newPkg.period;
      post('/modelPkg/save', JSON.stringify(this.newPkg)).then((res) => {
        this.showableComp.showAddModelPkg = false;
      });
    },
    submitModelPkg() {
      if (this.copyFlag) {
        this.modelPkgCopy();
        return;
      }
      if (this.newPkg == "") {
        this.addModelPkg();
      } else {
        this.saveModelPkg();
      }
    },
    /**
     * @function POST /modelPkg/search
     * @description 查询模型库
     * @param departmentId int 局ID
     * @param year int 年度
     * @returns R.success().code(200).data("modelPkgList")
     */
    searchModelPkg() {
      let data = {
        departmentId: JSON.parse(sessionStorage.getItem('departmentInfo')).departmentId,
        year: this.year,
      }
      post('/modelPkg/search', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.modelPkgData = JSON.parse(res.data.modelPkgs);
        }
      });
    },
    /**
     * @description 删除模型库，同时删除模型库下的模型
     * @function POST /modelPkg/delete
     * 
     * @param {int} id 模型库ID
     */
    handleDeletePkg(index, row) {
      post('/modelPkg/delete', row.id).then((res) => {
        if (res.code == 200) {
          this.modelPkgData.splice(index, 1);
        }
      });
    },
    /**
     * @function POST /model/search/batch
     * @description 根据模型库ID查询模型
     * 
     * @param pkgId 模型库ID
     * @returns R.success().code(200).data("modelList")
     */
    searchEvaModel() {
      // let data = { pkgId: this.selectedPkg.id };
      post('/model/search/batch', this.selectedPkg.id).then((res) => {
        if (res.code == 200) {
          res = JSON.parse(res.data.evaModelLists);
          for (let j = 0, len0 = res.length; j < len0; j++) {
            // 属性转换
            res[j].object = res[j].roleId;
            let subList = res[j].subjectList;
            res[j].subject = new Array();
            res[j].evaType = new Array();
            for (let i = 0, len = subList.length; i < len; i++) {
              res[j].subject.push(subList[i].roleId);
              res[j].evaType.push(subList[i].evaType);
            }
          }

          this.modelData = res;
        }
      });
    },
    /**
     * @function POST /evaModel/add
     * @description 添加模型。注意两张表：eva_model和model_role，首先在前一张表中创建一个模型对象返回一个主键ID值，再在后面的表中创建若干模型和考核主体即打分者绑定的对象并返回ID
     * 
     * @param pkgId 模型库ID
     * @param departmentId int 局ID
     * @param modelName 模型名称
     * @param available 是否可用
     * @param object 考核对象
     * @param objectType 考核对象类型：1为个人2为科室
     * @param season 季度
     * @param proportion 比例，该指标在当前考核对象的所有考核指标中所占比例
     * @param normName 指标名称
     * @param period 创建时间/周期
     * @param subjectModelList 该模型关联的考核主体集合/数组
     * @param subjectModelList[i].subjectName 考核主体名称
     * @param subjectModelList[i].evaType 考核类型
     * @param subjectModelList[i].proportion 比例，该指标不同考核主体评分所占比例
     * 
     * 
     * @returns R.success().code(200).data("modelId:模型ID, subjectModelIdList[]:model_role表中数据的ID");
     * 
     */
    addEvaModel() {
      let data = this.newModel;
      data.period = moment().format("YYYY-MM-DD");
      data.pkgId = this.selectedPkg.id;
      data.departmentId = JSON.parse(sessionStorage.getItem('departmentInfo')).departmentId;
      data.normName = getNormNameByTypeId(data.normId, 1);
      // let res = 0;
      // for (let i = 0, len = data.subjectModelList.length; i < len; i++) {
      //   res = res + parseInt(data.subjectModelList[i].proportion);
      // }
      // // 验证个考核主体比率之和是否为100
      // if (res != 100) {
      //   ElMessage({
      //     message: '比率之和不为100，请重新输入.',
      //     grouping: true,
      //     type: 'warning',
      //     duration: 3 * 1000,
      //   });
      //   return null;
      // }

      for (let i = 0, len = data.subjectModelList.length; i < len; i++) {
        if (parseInt(data.subjectModelList[i].proportion) > 100) {
          ElMessage({
            message: '单项评分比率大于100%，不予提交.',
            grouping: true,
            type: 'warning',
            duration: 3 * 1000,
          });
          return null;
        }
      }
      // 验证个考核主体比率之和是否为100
      post('/evaModel/add', JSON.stringify(data)).then((res) => {
        // 重新根据选中的模型库ID搜索模型数据并重新渲染表格
        this.searchEvaModel();
        this.showableComp.showAddModel = false;
      });
    },
    // 生成模型
    generateEvaModel() {
      this.newModel.subjectModelList = [];
      for (let i = 0, len = this.newModel.subject.length; i < len; i++) {
        this.subjectModel.subjectId = this.newModel.subject[i];
        // 解决浅拷贝的问题
        this.newModel.subjectModelList.push(JSON.parse(JSON.stringify(this.subjectModel)));
      }
      this.$refs.table2.doLayout();
    },
    // 取消添加
    onCancel() {
      this.showableComp.showAddModel = false;
    },

    /**
     * @description 根据modelId删除考核模型，modelId是eva_model表中的id，同时要删除model_role表中以此为modelId的数据
     * @function POST /evaModel/delete
     * 
     * @param modelId int 模型ID
     */
    handleDeleteModel(index, row) {
      let data = {
        modelId: row.modelId,
      };
      post('/evaModel/delete', JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          this.modelData.splice(index, 1);
        }
      });
    },
    modelPkgBtn() {
      this.copyFlag = true;
      this.newPkg = [];
      this.showableComp.showAddModelPkg = true;
    },
    /**
     * @description 模型库拷贝
     * @param Integer id 模型库id
     * @param String name 模型库名称
     * @param String period 季度（中文）
     * @param int season 季度（数字）
     * @param int departmentId 部门id
     * @param int year 年度
     */
    modelPkgCopy() {
      let data = {
        id: this.selectPkg.id,
        name: this.newPkg.name,
        season: this.newPkg.season,
        period: this.newPkg.period,
        departmentId: JSON.parse(sessionStorage.getItem('departmentInfo')).departmentId,
        year: this.year,
      };
      post('/modelPkg/copy', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          data.id = res.data.modelPgkId;
          this.modelPkgData.push(data);
        }
        this.showableComp.showAddModelPkg = false;
      });
    }
  },
  created() {
    this.modelPkgTable = modelPkgTable;
    this.modelTable = modelTable;
    this.modelPkgData = modelPkgData;
    this.modelData = modelData;
    this.searchModelPkg();
  },

};